import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VRow, [_c(VCol, [_c(VTextField, {
    attrs: {
      "label": _vm.$t('Dashboards.components.widgetTwinMapOptionsEditor.inputs.popupTitle.label'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled
    },
    model: {
      value: _vm.popupTitle,
      callback: function ($$v) {
        _vm.popupTitle = $$v;
      },
      expression: "popupTitle"
    }
  })], 1)], 1), _c('twin-attributes-selector', {
    attrs: {
      "twins": _vm.twins,
      "twin-filter": _vm.value.twinFilter,
      "virtual-device-filter": _vm.value.virtualDeviceFilter,
      "dashboard-id": _vm.dashboardId,
      "custom-parameters": _vm.customParameters
    },
    model: {
      value: _vm.attributes,
      callback: function ($$v) {
        _vm.attributes = $$v;
      },
      expression: "attributes"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };